import React from "react";
import { EMPTY_STRING } from "../../../constants";

const RoundedButton = ({
  variant = "contained",
  children,
  className = EMPTY_STRING,
  onClick = () => {},
  type = "button",
  cotainerClass = EMPTY_STRING,
  disabled = false,
}) => {
  return (
    <div className={`${cotainerClass}`}>
      <button
        type={type}
        className={`rounded-pill rounded-button text-center ${variant}-button ${className}`}
        onClick={onClick}
        disabled={disabled}
      >
        {children}
      </button>
    </div>
  );
};

export default RoundedButton;
